import { isMobile } from 'constants';

export function getOverlayContainer() {
  return isMobile ? document.getElementsByClassName('page-content')[0] : undefined;
}



// WEBPACK FOOTER //
// ./app/utils/mobile-utils.js